// extracted by mini-css-extract-plugin
export default {"section":"Ws-z","inSectionButton":"Xs-z","addressCard":"Ys-z","disabled":"Zs-z","cautionBox":"_s-z","failureBox":"at-z","fade-out":"bt-z","successBox":"ct-z"};